"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");







































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _aliOss = _interopRequireDefault(require("@/utils/aliOss")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { taskListData: [], // 列表数据
      organizationList: [], robotId: '', insId: '', addItem: false, newadd: false, modOrg: false, title: '', searchData: { name: '', insId: '', sn: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', name: '' }, rules: { name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'name', label: '名称', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }], defaultProps: { children: 'child', label: 'insName' } };}, mounted: function mounted() {var self = this;var orgId = self.$route.query.orgId;if (orgId) {self.searchData.insId = orgId;}self.getTask();}, methods: { getTask: function getTask() {var self = this;self.getData('/api/temi/robot/task', self.searchData, function (res) {self.taskListData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.getTask();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.getTask();}, checkPermission: _user.checkPermission, addFun: function addFun() {// 新增
      this.title = '新增';this.addItem = true;}, closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addTask'].resetFields();this.cleanData();this.addItem = false;this.addItem2 = false;}, updateMenu: function updateMenu(item) {// 修改操作
      this.title = '修改';var self = this;self.addItem = true;self.addData = { name: item.name, id: item.id };}, onSubmit: function onSubmit() {// 新增提交操作
      var self = this;self.$refs.addTask.validate(function (valid) {
        if (valid) {
          var postData = {
            'task': {
              'name': self.addData.name,
              'id': self.addData.id },

            'robotIds': [] };

          self.postData('/api/temi/robot/task', postData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.getTask();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(taskId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/robot/task?id=' + taskId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.onCencal();
          self.getTask();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.cleanData();
      this.addItem = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        name: '' };

    },
    fnUploadRequest: function fnUploadRequest(option) {
      var path = 'temi/task';
      _aliOss.default.ossUploadFile(option, path);
    },
    checkFn: function checkFn(node, data) {
      var currKey = node.id;
      this.$refs.taskTree.setCheckedKeys([currKey]);
      this.taskId = currKey;
      // this.$emit('getClidTask', node.image)
      this.$emit('getTask', node);
    },
    changeTask: function changeTask(image) {
      this.taskSrc = image;
    },
    returnFun: function returnFun(item) {
      // 返回上一级
      var self = this;
      self.$router.push({ path: '/temi/taskDetail', query: { data: item } });
    } } };exports.default = _default;